












import { defineComponent, PropType } from '@nuxtjs/composition-api'
import useHelper from '@/utils/helper'
import { StoryblokComponent } from '~/types/storyblok-vue'

export interface GaContainer extends StoryblokComponent<'container'> {
  content: StoryblokComponent<any>[]
  custom_classes: string
}

export default defineComponent({
  props: {
    blok: {
      type: Object as PropType<GaContainer>,
      default: () => {}
    }
  },
  setup(props, context) {
    const { concatClasses, dashify } = useHelper()
    const classes = concatClasses(props.blok)

    const handleClick = (event: any) => {
      console.log('blub')
      context.emit('click', event)
    }

    return {
      classes,
      dashify,
      handleClick
    }
  }
})
